<template>
    <div id="root">
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         src="@/assets/theme/light/status/01dailyActive/01back.svg">
                    </van-col>
                    <van-col span="12">
                    </van-col>
                    <van-col span="6" @click="showEditBox = true"><img class="back-icon right-icon"
                                                                       src="@/assets/theme/light/trainPlan/06planDesc/01more.svg">
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="edit-box" v-if="showEditBox" ref="showContent">
                <div class="edit-item" @click="toPlanEdit">{{ $t('planDesc.edit') }}</div>
                <div class="edit-item red" v-if="userPlanId" @click="showOutTip">{{ $t('planDesc.out') }}</div>
                <div class="edit-item red" v-else @click="deletePlanBefore">{{ $t('planDesc.delete') }}</div>
            </div>
            <div class="title">{{ planName }}</div>
            <div class="sub-info" v-if="planId">{{ groupCount }}{{ $t('planLibrary.group') }} | {{
                    totalCapacity
                }}{{ $t('planLibrary.capacity') }}
            </div>
            <div class="sub-info" v-if="userPlanId">
                {{ getRepeatWeekText(weeklyRepeat) }}（{{ startDate }}~{{ endDate }}）
            </div>
            <div class="group-item" v-for="item in actionList">
                <van-row class="group-top">
                    <van-col span="5">
                        <img class="active-icon" :src="item.bannerUrl">
                    </van-col>
                    <van-col span="19">
                        <div class="flex-line">
                            <div class="action-name" v-if="$i18n.locale === 'en'">{{ item.actionNameEn }}</div>
                            <div class="action-name" v-else-if="$i18n.locale === 'ja'">{{ item.actionNameJa }}</div>
                            <div class="action-name" v-else>{{ item.actionName }}</div>
                            <div class="action-capacity" v-if="item.recordType == 1">{{ item.capacity }}
                                {{ $t('planEdit.capacity') }}
                            </div>
                        </div>
                        <div class="add-title-box" :class="{'add-title-box-ja':$i18n.locale === 'ja'}" v-if="item.recordType == 1">
                            <div class="group-title">{{ $t('planEdit.group') }}</div>
                            <div class="weight-title">{{ $t('planEdit.weight') }}</div>
                            <div class="f-title">{{ $t('planEdit.frequency') }}</div>
                            <div class="distance-unit-box">
                                {{ item.unit }}
                            </div>
                        </div>
                        <div class="add-title-box" :class="{'add-title-box-ja':$i18n.locale === 'ja'}" v-if="item.recordType == 2">
                            <div class="group-title">{{ $t('planEdit.group') }}</div>
                            <div class="weight-title">{{ $t('planEdit.duration') }}</div>
                        </div>
                        <div class="add-title-box" :class="{'add-title-box-ja':$i18n.locale === 'ja'}" v-if="item.recordType == 3">
                            <div class="group-title">{{ $t('planEdit.group') }}</div>
                            <div class="weight-title">{{ $t('planEdit.frequency') }}</div>
                        </div>
                        <div class="add-title-box" :class="{'add-title-box-ja':$i18n.locale === 'ja'}" v-if="item.recordType == 4">
                            <div class="group-title">{{ $t('planEdit.group') }}</div>
                            <div class="weight-title">{{ $t('planEdit.distance') }}</div>
                            <div class="distance-unit-box">km</div>
                        </div>
                        <div class="add-line" v-for="(group, index) in item.actionList" :key="index">
                            <div class="add-index">{{ index + 1 }}</div>
                            <div class="add-weight-input" v-if="item.recordType == 1">
                                <van-field class="group-input" type="digit" input-align="center"
                                           v-model="group.w" readonly/>
                            </div>
                            <div class="add-f-input" v-if="item.recordType == 1">
                                <van-field class="group-input" type="digit" input-align="center"
                                           v-model="group.f" readonly/>
                            </div>
                            <div class="add-weight-input" v-if="item.recordType == 2">
                                <div class="group-input duration-input">{{SwitchTime24(group.t)}}</div>
                            </div>
                            <div class="add-weight-input" v-if="item.recordType == 3">
                                <van-field class="group-input" type="digit" input-align="center"
                                           v-model="group.f" readonly/>
                            </div>
                            <div class="add-weight-input" v-if="item.recordType == 4">
                                <van-field class="group-input" type="digit" input-align="center"
                                           v-model="group.d" readonly/>
                            </div>
                        </div>
<!--                        <div class="time-box" v-if="item.recordType == 2">-->
<!--                            {{ $t('planEdit.common') }}-->
<!--                            <div class="add-time-input">-->
<!--                                <van-field class="group-input" type="digit" input-align="center"-->
<!--                                           v-model="item.actionList[0].c" readonly/>-->
<!--                            </div>-->
<!--                            {{ $t('planEdit.group') }}-->
<!--                        </div>-->
                    </van-col>
                </van-row>
            </div>
            <div class="bottom-box" v-if="!userPlanId" @click="toSetPlanDate">
                <div><img class="import-img" src="@/assets/theme/light/trainPlan/05setPlanDate/02can.svg"></div>
                <div>{{ $t('setPlanDate.import') }}</div>
            </div>
            <!--            <div class="bottom-box" v-if="userPlanId" @click="toStartTrain">-->
            <!--                <div><img class="import-img" src="@/assets/theme/light/trainPlan/06planDesc/01play.svg"></div>-->
            <!--                <div>{{ $t('planDesc.start') }}</div>-->
            <!--            </div>-->
            <!--            <van-row class="bottom-box" v-else>-->
            <!--                <van-col span="12">-->
            <!--                    <div><img class="import-img" src="@/assets/theme/light/trainPlan/06planDesc/01play.svg"></div>-->
            <!--                    <div>{{ $t('planDesc.start') }}</div>-->
            <!--                </van-col>-->
            <!--                <van-col span="12" @click="toSetPlanDate">-->
            <!--                    <div><img class="import-img" src="@/assets/theme/light/trainPlan/05setPlanDate/02can.svg"></div>-->
            <!--                    <div>{{ $t('setPlanDate.import') }}</div>-->
            <!--                </van-col>-->
            <!--            </van-row>-->
        </div>
    </div>
</template>

<script>
import {deletePlan, getPlanLibraryById} from "../../api/trainPlan";
import {Dialog, Toast} from "vant";
import {WebJSBridge} from "../../utils/JSBridge1";
import {SwitchTime24} from "../../utils/dateUtils";

export default {
    name: 'planDesc',
    data() {
        return {
            planId: '',
            userPlanId: '',
            planName: '',
            groupCount: 0,
            totalCapacity: 0,
            actionList: [],
            startDate: '',
            endDate: '',
            weeklyRepeat: '',
            planLibrary: {},
            userTrainPlan: {},
            showEditBox: false,
            from: '',
            theme: 'light'
        }
    },
    watch: {
        showEditBox: {
            handler(newVal, olVal) {
                if (newVal) {
                    setTimeout(() => {
                        document.addEventListener('click', this.checkClick);
                    }, 0);
                } else {
                    document.removeEventListener('click', this.checkClick);
                }
            }
        }
    },
    mounted() {
        if (this.$route.query.planId) {
            this.planId = this.$route.query.planId;
        }
        if (this.$route.query.userPlanId) {
            this.userPlanId = this.$route.query.userPlanId;
        }
        if (this.$route.query.from) {
            this.from = this.$route.query.from;
        }
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme;
        }
        this.getPlanDetail();
    },
    methods: {
        SwitchTime24(n) {
            if (!n) {
                return '00:00:00'
            }
            return SwitchTime24(n)
        },
        checkClick(event) {
            let dom = this.$refs.showContent; // 这里是你的下拉菜单元素
            if (!dom.contains(event.target)) {
                // 不在菜单范围，隐藏即可
                if (this.showEditBox) {
                    this.showEditBox = false;
                    document.removeEventListener('click', this.checkClick);
                }
            }
        },
        back() {
            if (this.from === 'web') {
                this.$router.back();
            } else {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            }
        },
        getPlanDetail() {
            if (this.planId) {
                this.$api.trainPlan.getPlanLibraryById({
                    planId: this.planId
                }).then(res => {
                    this.planLibrary = res.info;
                    this.planName = res.info.planName;
                    this.groupCount = res.info.groupCount;
                    this.totalCapacity = res.info.totalCapacity;
                    this.actionList = res.info.actionList;
                    this.initActionList(res.info);
                })
            } else if (this.userPlanId) {
                this.$api.trainPlan.getUserTrainPlanById({
                    userPlanId: this.userPlanId
                }).then(res => {
                    this.userTrainPlan = res.info;
                    this.planId = res.info.planId;
                    this.planName = res.info.planName;
                    this.groupCount = res.info.groupCount;
                    this.totalCapacity = res.info.totalCapacity;
                    this.actionList = res.info.actionList;
                    this.startDate = res.info.startDate;
                    this.endDate = res.info.endDate;
                    this.weeklyRepeat = res.info.weeklyRepeat;
                    this.initActionList(res.info);
                })
            }
        },
        getRepeatWeekText(repeatWeek) {
            let arr = repeatWeek.split(',');
            if (arr.length === 1) {
                return this.$t('setPlanDate.repeatText') + this.$t('setPlanDate.repeatText' + arr[0]);
            } else if (arr.length === 7) {
                return this.$t('setPlanDate.repeatText7')
            } else {
                let text = this.$t('setPlanDate.repeatText');
                for (let i = 0; i < arr.length; i++) {
                    if (i === arr.length - 1) {
                        text = text + this.$t('setPlanDate.repeatText' + arr[i])
                    } else {
                        text = text + this.$t('setPlanDate.repeatText' + arr[i]) + this.$t('setPlanDate.repeatTextSplit');
                    }
                }
                return text;
            }
        },
        showOutTip() {
            Dialog.confirm({
                title: this.$t('planDesc.outPlan'),
                message: this.$t('planDesc.outPlanDesc'),
                getContainer: "#root",
                confirmButtonColor: '#00BD9B',
                confirmButtonText: this.$t('planDesc.confirm'),
                cancelButtonText: this.$t('planDesc.cancel'),
                cancelButtonColor: 'rgb(133 130 130)',
            }).then(() => {
                this.$api.trainPlan.exitUserTrainPlan({
                    userPlanId: this.userPlanId
                }).then(res => {
                    WebJSBridge.call("calendarEditSuccess", null, function (res) {
                    });
                    this.$router.back()
                })
            }).catch(() => {
            });
        },
        deletePlanBefore() {
            this.$api.trainPlan.checkUserTrainPlanProgress({
                planId: this.planId
            }).then(res => {
                if (res.info === 0) {
                    this.deletePlan(0);
                } else {
                    Dialog.confirm({
                        title: this.$t('planDesc.deleteTitle'),
                        message: this.$t('planDesc.deleteDesc'),
                        getContainer: "#root",
                        confirmButtonColor: '#00BD9B',
                        confirmButtonText: this.$t('planDesc.confirm'),
                        cancelButtonText: this.$t('planDesc.cancel'),
                        cancelButtonColor: 'rgb(133 130 130)',
                    }).then(() => {
                        this.deletePlan(1);
                    }).catch(() => {
                    });
                }
            })
        },
        deletePlan(tag) {
            this.$api.trainPlan.deletePlan({
                planId: this.planId
            }).then(res => {
                Toast({message: this.$t('planDesc.success')});
                WebJSBridge.call("planEditSuccess", null, function (res) {
                });
                if (tag) {
                    WebJSBridge.call("calendarEditSuccess", null, function (res) {
                    });
                }
                this.$router.back()
            })
        },
        toSetPlanDate() {
            this.$router.push({
                name: 'setPlanDate',
                query: {
                    planId: this.planId,
                    lang: this.$i18n.locale,
                    theme: this.theme
                }
            })
        },
        toPlanEdit() {
            this.$router.push({
                name: 'planEdit',
                query: {
                    planId: this.planId,
                    from: 'web',
                    lang: this.$i18n.locale,
                    theme: this.theme
                }
            })
        },
        toStartTrain() {
            this.$router.push({
                name: 'startTrain',
                query: {
                    userPlanId: this.userPlanId,
                    lang: this.$i18n.locale,
                    theme: this.theme
                }
            })
        },
        initActionList(obj) {
            let actionListGroup = JSON.parse(obj.actionListGroup)
            let actionListUnit = [];
            if (obj.actionListUnit) {
                actionListUnit = obj.actionListUnit.split(',')
            }
            let index = 0;
            // 将 actionId 字符串解析为数组
            const actionIdArray = obj.actionListId.split(',').map(Number);

            // 根据 actionIdArray 的顺序对 actionList 进行排序
            this.actionList.sort((a, b) => {
                return actionIdArray.indexOf(a.actionId) - actionIdArray.indexOf(b.actionId);
            });
            for (let i = 0; i < this.actionList.length; i++) {
                this.actionList[i].currentIndex = 0
                this.actionList[i].currentCapacity = 0
                this.actionList[i].currentf = 0
                this.actionList[i].currentd = 0
                this.actionList[i].f = 0
                this.actionList[i].d = 0
                this.actionList[i].capacity = 0
                this.actionList[i].actionList = actionListGroup[i]
                if (actionListUnit.length > 0) {
                    this.actionList[i].unit = actionListUnit[i]
                }
                for (let j = 0; j < this.actionList[i].actionList.length; j++) {
                    this.actionList[i].actionList[j].isFinish = 0;
                    this.actionList[i].actionList[j].duration = 0;
                    this.actionList[i].actionList[j].rt = 0;
                    this.actionList[i].actionList[j].index = index;
                    index++;
                    if (this.actionList[i].recordType === 3) {
                        this.actionList[i].f = this.actionList[i].f + parseInt(this.actionList[i].actionList[j].f);
                    }
                    if (this.actionList[i].recordType === 4) {
                        this.actionList[i].d = this.actionList[i].d + parseInt(this.actionList[i].actionList[j].d);
                    }
                    if (this.actionList[i].recordType === 1) {
                        this.actionList[i].capacity = this.actionList[i].capacity + parseInt(this.actionList[i].actionList[j].f) * parseInt(this.actionList[i].actionList[j].f);
                    }
                }
            }
            console.log(this.actionList);
        },
    }
}
</script>

<style scoped>

.content {
    width: 100%;
    margin-top: 98px;
    color: var(--text-color-1);
    position: relative;
}

.right-icon {
    float: right;
}

.title {
    font-size: 22px;
    margin-left: 31px;
    margin-bottom: 8px;
    line-height: 22px;
}

.sub-info {
    font-size: 12px;
    color: var(--text-color-2);
    margin-left: 31px;
    line-height: 12px;
    margin-bottom: 16px;
}

.group-item {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 0 auto 12px;
}

.active-icon {
    width: 46px;
    margin-left: 18px;
}

.group-top {
    padding-top: 15px;
}

.flex-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.action-name {
    font-size: 17px;
    color: var(--text-color-1);
}

.action-capacity {
    font-size: 12px;
    color: var(--text-color-2);
    margin-right: 22px;
}


.action-num {
    font-size: 12px;
    color: var(--text-color-3);
}

.action-omit {
    color: var(--text-color-2);
    font-size: 24px;
    margin-right: 22px;
}

.add-top-line {
}

.add-title-box {
    width: 100%;
    height: 30px;
    position: relative;
    color: var(--text-color-3);
    font-size: 12px;
}

.add-title-box-ja {
    height: 45px;
}

.group-title {
    position: absolute;
    left: 0;
    top: 6px;
    width: 40px;
}

.weight-title {
    position: absolute;
    width: 46px;
    text-align: center;
    left: 37px;
    top: 6px;
}

.f-title {
    position: absolute;
    width: 46px;
    text-align: center;
    left: 96px;
    top: 6px;
}

.unit-box {
    width: 52px;
    height: 21px;
    background: var(--bg-color-1);
    border-radius: 7px 7px 7px 7px;
    position: absolute;
    right: 22px;
    top: 4px;
}

.kg-unit {
    width: 26px;
    height: 21px;
    border-radius: 7px 7px 7px 7px;
    position: absolute;
    left: 0;
    text-align: center;
    line-height: 21px;
}

.lbs-unit {
    width: 26px;
    height: 21px;
    border-radius: 7px 7px 7px 7px;
    position: absolute;
    right: 0;
    text-align: center;
    line-height: 21px;
}

.active {
    background: #00BD9B;
    color: var(--bg-color-2);
}

.add-weight-input {
    position: absolute;
    left: 37px;
}

.group-input {
    background-color: var(--bg-color-1);
    width: 46px;
    height: 32px;
    border-radius: 8px;
    padding: 4px;
}

.add-line {
    width: 100%;
    position: relative;
    height: 32px;
    padding-bottom: 10px;
}

.add-index {
    font-size: 13px;
    color: var(--text-color-1);
    text-align: center;
    height: 32px;
    line-height: 32px;
    position: absolute;
    left: 0;
}

.add-f-input {
    position: absolute;
    left: 96px;
}

.total-capacity {
    font-size: 12px;
    color: var(--text-color-2);
    float: right;
    margin-right: 22px;
}

.distance-unit-box {
    height: 21px;
    border-radius: 7px 7px 7px 7px;
    font-size: 12px;
    color: var(--text-color-2);
    text-align: center;
    line-height: 21px;
    position: absolute;
    right: 25px;
}

.time-box {
    width: 100%;
    height: 46px;
    position: relative;
    font-size: 12px;
    color: var(--text-color-3);
    padding-top: 10px;
}

.add-time-input {
    display: inline-block;
    margin: 0 8px;
}

.bottom-box {
    width: 345px;
    height: 65px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    bottom: 15px;
    text-align: center;
    font-size: 12px;
    margin: 12px auto;
}

.import-img {
    width: 16px;
    height: 16px;
    margin-top: 13px;
}

.edit-box {
    position: absolute;
    right: 15px;
    width: 70px;
    box-shadow: 0px 0px 8px 1px rgba(216, 216, 216, 0.5);
    border-radius: 5px 5px 5px 5px;
    background-color: var(--bg-color-2);
    z-index: 1111;
    top: 0px;
    padding: 10px 0 0;
    text-align: left;
}

.edit-item {
    height: 30px;
    color: var(--text-color-1);
    font-size: 15px;
    line-height: 22px;
    margin-left: 18px;
}

.red {
    color: #FF0101;
}

/deep/ .van-dialog__header {
    color: var(--text-color-1);
}

/deep/ .van-dialog__message {
    font-size: 15px;
    color: var(--text-color-2);
    line-height: 23px;
    text-align: center;
}

.duration-input {
    width: 105px;
    padding: 0;
    text-align: center;
    font-size: 14px;
    line-height: 32px;
}

/deep/ .van-field__control {
    color: var(--text-color-1);
}
</style>


// WEBPACK FOOTER //
// src/views/trainPlan/06planDesc.vue